export default "__VITE_ASSET__Dsaf2nkf__"